import { z } from 'zod'

export const filterParticipantsEstimativeSchema = z.object({
  startDate: z.string(),
  endDate: z.string()
})
